import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const trendyeldConfig: TSPConfig = {
  key: 'trendyeld',
  name: 'Trendy ELD',
  imageName: 'TrendyELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API token from Trendy ELD support, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API token' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default trendyeldConfig;
